<script>
  'use strict'

  import { _tileMap, _tilesCollections, _tilesCollectionFileName, _currentMode, _selectedTileIdx, _newProject } from '../store/store';
  import AutoSaveMap from './AutoSaveMap.svelte';
  import ProjectImport from './ProjectImport.svelte';
  import FileManagementClear from './FileManagementClear.svelte';

  let exportFile;
  let projectName = '';

</script>

<AutoSaveMap bind:this={exportFile}></AutoSaveMap>

<div class="file-management-sections">
  <div class="btns-file-management">
    <h4>Save</h4>
    <input class="filename-input" type="text" placeholder="Project name" bind:value={projectName}>
    <button on:click="{() => exportFile.saveProjectFileLocally(projectName)}">SAVE PROJECT</button>
  </div>
  <div>
    <h4>Import</h4>
    <ProjectImport></ProjectImport>
  </div>
  <div class="btns-file-management">
    <h4>Clear</h4>
    <FileManagementClear></FileManagementClear>
  </div>
</div>


<style>

.file-management-sections {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.filename-input {
    background: transparent;
    color: var(--font-color);
    border-radius: 0;
  }

  .btns-file-management {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding-bottom: 6px;
    margin-bottom: 24px;
    /* border-bottom: 1px solid var(--font-color); */
  }
</style>
